import { html, TemplateResult } from 'lit';

/**
 * Renders a design-system icon through nile-glyph. ng-prefixed names are
 * stroke-drawn in @aquera/nile-glyph's set; the rest are fill-drawn.
 */
export function renderGlyph(name: string, size: number): TemplateResult {
  return html`<nile-glyph
    name=${name}
    size=${size}
    method=${name.startsWith('ng-') ? 'stroke' : 'fill'}
  ></nile-glyph>`;
}
